import React from 'react';
import {
    CardActions,
    Datagrid,
    Filter,
    FunctionField,
    List,
    SelectInput,
    Show,
    SimpleShowLayout,
    TextField,
    TextInput,
} from 'react-admin';
import { CustomPagination, stylesWide } from '../utils';
import { withStyles } from '@material-ui/core/styles';
import VirtualStationActions from './actions';

const StationsFilter = props => (
    <Filter {...props}>
        <SelectInput
            label="Поле"
            source="field"
            choices={[
                { id: 'id', name: 'Id' },
                { id: 'sno', name: 'Sno' },
                { id: 'location_id', name: 'ID локации' },
                { id: 'holder_short_number', name: 'Короткий номер' },
            ]}
            alwaysOn
        />
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);


export const LocationIdField = ({ record = {} }) => {
    if (record.location)
        return (
            <span>
                {record.location.id} ({record.location.name})
            </span>
        );
    return <span/>;
};
LocationIdField.defaultProps = { label: 'Локация' };

export const AdminUserField = ({ record = {} }) => {
    if (record.admin_user_virtual)
        return (
            <span>
                {record.admin_user_virtual.id} ({record.admin_user_virtual.name})
            </span>
        );
    return <span/>;
};
AdminUserField.defaultProps = { label: 'Локация' };

export const VirtualStationsList = ({ permissions, ...props }) => (
    <List
        {...props}
        filters={<StationsFilter/>}
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="show">
            <TextField
                label="Id"
                source="id"
            />
            <TextField
                label="Sno"
                source="sno"
            />
            <AdminUserField
                label="Пользователь"
                source="admin_user_virtual"
            />
            <LocationIdField
                label="Локация"
                source="location"
            />
            <TextField
                label="Короткий номер"
                source="holder_short_number"
            />
            <TextField
                label="Статус"
                source="status"
            />
        </Datagrid>
    </List>
);

const VirtualStationActionsRaw = ({ data, permissions, resource }) => (
    <CardActions
        submitOnEnter={false}
        style={{ display: 'flex', 'flexDirection': 'row', 'justifyContent': 'space-between'}}
    >
        <VirtualStationActions
                record={data}
                resource={resource}
                permissions={permissions}
        />
    </CardActions>
);

export const ShowVirtualStation = withStyles(stylesWide)(({ classes, permissions, ...props }) => {
    return (
        <Show classes={classes} {...props} actions={<VirtualStationActionsRaw {...props} permissions={permissions} />}>
            <SimpleShowLayout classes={classes}>
                <TextField
                    label="Id"
                    source="id"
                    className={classes.wide}
                />
                <TextField
                    label="Sno"
                    source="sno"
                    className={classes.wide}
                />
                <TextField
                    label="QR"
                    source="station_qr"
                    className={classes.wide}
                />
                <FunctionField
                    label="Пользователь"
                    render={record => record.admin_user_virtual ? `${record.admin_user_virtual.id}${record.admin_user_virtual.name ? ` (${record.admin_user_virtual.name})` : ''}` : ''}
                    className={classes.wide}
                />
                <FunctionField
                    label="Локация"
                    render={record => record.location ? `${record.location.id}${record.location.name ? ` (${record.location.name})` : ''}` : ''}
                    className={classes.wide}
                />
                <TextField
                    label="Короткий номер"
                    source="holder_short_number"
                    className={classes.wide}
                />
                <TextField
                    label="Статус"
                    source="status"
                    className={classes.wide}
                />
            </SimpleShowLayout>
        </Show>
    );
});
